module.exports = __webpack_public_path__ + "static/media/4.b737a35d.jpg";